module.exports = __webpack_public_path__ + "img/down-button.70c38827.svg";